import type { ComponentProps } from "react"
import type { IssueStatus } from "~/lib/enums"
import { enumFormat } from "~/lib/utils"
import { IssuePropertyIcon } from "./IssuePropertyIcon"

export const statusConfigs = {
	ToDo: { color: "light-dark(#64748b, #a3adbd)" },
	InProgress: { color: "light-dark(#a16207, #e8bd62)" },
	InReview: { color: "light-dark(#6d28d9, #b69aef)" },
	Complete: { color: "light-dark(#047857, #6acba2)" },
	Blocked: { color: "light-dark(#be123c, #f07d96)" },
	Canceled: { color: "light-dark(#64748b, #a3adbd)" },
	Queue: { color: "light-dark(#64748b, #a3adbd)" }
} satisfies Record<IssueStatus, { color: string }>

export function StatusIcon({
	status,
	...props
}: Omit<ComponentProps<"svg">, "color"> & {
	status: IssueStatus
	withText?: boolean
}) {
	return (
		<IssuePropertyIcon
			label={enumFormat(status)}
			color={statusConfigs[status].color}
			{...props}
		>
			{status === "InReview" ? (
				<>
					<path d="M1.5 8S3.75 3.75 8 3.75 14.5 8 14.5 8 12.25 12.25 8 12.25 1.5 8 1.5 8Z" />
					<circle cx="8" cy="8" r="1.75" fill="currentColor" stroke="none" />
				</>
			) : (
				<circle
					cx="8"
					cy="8"
					r="5.75"
					strokeDasharray={status === "Queue" ? "1 3" : undefined}
					fill="currentColor"
					fillOpacity={status === "Complete" || status === "Blocked" ? 0.12 : 0}
				/>
			)}
			{status === "InProgress" && (
				<path
					d="M8 4.25a3.75 3.75 0 0 1 0 7.5Z"
					fill="currentColor"
					stroke="none"
				/>
			)}
			{status === "Complete" && <path d="m5.25 8 1.8 1.8 3.7-3.7" />}
			{status === "Blocked" && <path d="M5.5 8h5" />}
			{status === "Canceled" && <path d="m6 6 4 4m0-4-4 4" />}
		</IssuePropertyIcon>
	)
}
